import {PlusOutlined} from '@ant-design/icons';
import {
    Button,
    Divider,
    Form,
} from 'antd';
import {FormInstance} from 'antd/es/form';
import cn from 'classnames';
import React, {useState, FC} from 'react';

import {RichTextEditor} from 'components/rich-text';
import {TEntityValue} from 'modules/data/data-types';

import {IDocumentStatusChangeForm} from '../../document-status-change-modal.types';
import {DocumentCommentRow} from './comment-row';

import './comments-form-content.less';

interface ICommentsFormContentProps {
    selectedDocuments: Record<string, TEntityValue>[];
    hidden?: boolean;
    form: FormInstance<IDocumentStatusChangeForm>;
}

export const CommentsFormContent: FC<ICommentsFormContentProps> = ({
    selectedDocuments,
    hidden,
    form,
}: ICommentsFormContentProps) => {
    const [activeCommentId, setActiveCommentId] = useState<string | null>(null);
    const [showSharedComment, setShowSharedComment] = useState<boolean>(false);

    const toggleComment = (docId: string) => {
        setActiveCommentId(prevId => (prevId === docId ? null : docId));
    };

    const isMultipleDocuments = selectedDocuments.length > 1;

    return (
        <div
            className={cn('comments-form-content__container', {
                'comments-form-content__container--hidden': hidden,
            })}
        >
            {isMultipleDocuments && (
                <>
                    {selectedDocuments.map(item => (
                        <DocumentCommentRow
                            key={item?.id as string}
                            id={item?.id as string}
                            docName={item?.docName as string}
                            isActive={activeCommentId === item?.id}
                            handleToggleComment={toggleComment}
                            form={form}
                        />
                    ))}
                    <Divider className="comments-form-content__divider-at-shared-comment-field" />
                </>
            )}

            {isMultipleDocuments && !showSharedComment && (
                <Button
                    type="default"
                    className="comments-form-content__add-shared-button"
                    icon={<PlusOutlined />}
                    onClick={() => setShowSharedComment(true)}
                >
                    Добавить общий комментарий
                </Button>
            )}
            {(!isMultipleDocuments || showSharedComment) && (
                <Form.Item
                    name="sharedComment"
                    label="Комментарий (необязательно)"
                    className="comments-form-content__shared-comment-field"
                >
                    <RichTextEditor
                        key="shared-comment"
                        placeholder="Введите комментарий"
                        toolbarId="shared-comment"
                    />
                </Form.Item>
            )}
        </div>
    );
};
